import { Card, Input, Button, Message } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'

interface RedeemCardProps {
  value: string
  loading: boolean
  onChange: (v: string) => void
  onRedeem: () => void
}

export default function RedeemCard({ value, loading, onChange, onRedeem }: RedeemCardProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('tt.topup.redeemTitle')} className="!rounded-2xl">
      <p className="text-[13px] text-[#6B7280] mb-3">{t('tt.topup.redeemHint')}</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Input
          placeholder={t('tt.topup.redeemPlaceholder')}
          value={value}
          onChange={onChange}
          onPressEnter={() => {
            if (!value.trim()) {
              Message.warning(t('tt.topup.redeemPlaceholder'))
              return
            }
            onRedeem()
          }}
          className="w-full sm:flex-1"
        />
        <Button type="primary" loading={loading} onClick={onRedeem}>
          {t('tt.topup.redeemNow')}
        </Button>
      </div>
    </Card>
  )
}
